'use client';

import { c as _c } from "react/compiler-runtime";
import { OnrampApiError } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import { type ReactNode, useEffect, useRef } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { TOAST_IDS } from '@/config/toast-ids';
import { logger } from '@/lib/telemetry/logger';
import { showToast } from '@/lib/ui/toast';
import { FundingStatusHeader } from '../history/funding-status-header';
interface FundingErrorProps {
  error: Error;
  withdrawal?: boolean;
  onRetry(): void;
  onSignIn(): void;
}
export function FundingError(t0) {
  const $ = _c(18);
  const {
    error,
    onRetry,
    onSignIn,
    withdrawal: t1
  } = t0;
  const withdrawal = t1 === undefined ? false : t1;
  const t = useTranslations("onramp");
  const expired = error instanceof OnrampApiError && error.status === 401;
  const announcedError = useRef(null);
  let t2;
  let t3;
  if ($[0] !== error || $[1] !== expired || $[2] !== t || $[3] !== withdrawal) {
    t2 = () => {
      if (!withdrawal || announcedError.current === error) {
        return;
      }
      announcedError.current = error;
      showToast({
        id: TOAST_IDS.ONRAMP_CHECKOUT_ERROR,
        message: t(expired ? "session_expired" : error instanceof OnrampApiError && [400, 422].includes(error.status) ? "payment_invalid_request" : "provider_unavailable"),
        variant: "error"
      });
      logger.warn("offramp.request_failed", {
        code: error instanceof OnrampApiError ? error.code : "offramp_request_failed",
        ...(error instanceof OnrampApiError ? {
          status: error.status,
          requestId: error.requestId
        } : {})
      });
    };
    t3 = [withdrawal, error, expired, t];
    $[0] = error;
    $[1] = expired;
    $[2] = t;
    $[3] = withdrawal;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (withdrawal) {
    return null;
  }
  let t4;
  if ($[6] !== expired || $[7] !== t) {
    t4 = expired ? <p className="text-body text-foreground-secondary">{t("session_expired")}</p> : <FundingStatusHeader artwork="offline" title={t("history_error_title")} description={t("history_error")} />;
    $[6] = expired;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = expired ? onSignIn : onRetry;
  let t6;
  if ($[9] !== expired || $[10] !== t) {
    t6 = expired ? t("sign_in") : t("retry");
    $[9] = expired;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <AnimatedButton className="h-11 rounded-control" onClick={t5}>{t6}</AnimatedButton>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <div role="alert" className="flex flex-col gap-4.5">{t4}{t7}</div>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}